import { jsxs as t, jsx as a } from "react/jsx-runtime";
import { clsx as c } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { remCalc as j } from "../../style/base/index.js";
import { formatRequiredLabel as z } from "../../utils/label-formatter.js";
import { RocheUIIcon as N } from "../icon/roche-icon.js";
import { RocheUITooltip as K } from "../tooltip/roche-tooltip.js";
import e from "./roche-select.module.scss.js";
import { RocheUISelectSize as y } from "./roche-select-types.js";
const I = `${j(14)}rem`, Q = ({
  disabled: s,
  label: d,
  options: g,
  isMultiSelect: r,
  showError: i,
  required: p = !1,
  tooltip: b,
  tooltipAriaLabel: x,
  selected: m,
  onBlur: o,
  onSelect: w,
  error: u,
  fullWidth: C = !1,
  size: L = y.DEFAULT,
  ...$
}) => {
  const k = r ? "checkbox" : "radio", R = F(d) || "selectGroupName", v = (l) => {
    w(l);
  }, S = () => {
    o == null || o();
  }, U = (l) => r && Array.isArray(m) ? m.includes(l) : m === l, A = (l, _) => {
    l.key === "Enter" && r && v(_);
  }, D = c(
    e.select,
    s && e["select--disabled"],
    C && e["select--full-width"],
    L === y.SMALL && e["select--size-small"]
  );
  return /* @__PURE__ */ t("div", { className: D, children: [
    /* @__PURE__ */ t("div", { className: e["select__label-wrapper"], children: [
      /* @__PURE__ */ a("span", { className: c(e.select__label, s && e["select__label--disabled"]), children: z(p, d) }),
      b && /* @__PURE__ */ a(K, { ariaLabel: x, children: b })
    ] }),
    g.map((l, _) => {
      const f = U(l.value || l.label), n = s || l.disabled, h = `select-item-${l.value}-${_}`, E = `${h}-error`;
      return /* @__PURE__ */ t(
        "label",
        {
          className: c(
            e["select__input-wrapper"],
            n && e["select__input-wrapper--disabled"]
          ),
          children: [
            /* @__PURE__ */ a(
              "input",
              {
                type: k,
                id: h,
                name: R,
                value: l.value || l.label,
                required: p,
                checked: f,
                disabled: n,
                onChange: () => v(l),
                onBlur: S,
                className: e["select__native-input"],
                onKeyDown: (T) => A(T, l),
                "aria-invalid": i,
                "aria-describedby": i ? E : void 0,
                ...$
              }
            ),
            /* @__PURE__ */ a(
              "div",
              {
                className: c(
                  e["select__native-input-custom-control"],
                  i && e["select__native-input-custom-control--invalid"]
                ),
                children: f && /* @__PURE__ */ a(
                  "div",
                  {
                    className: c(
                      e["select__native-input-icon"],
                      n && e["select__native-input-icon--disabled"]
                    ),
                    children: /* @__PURE__ */ a(
                      N,
                      {
                        icon: r ? "checkmark" : "circle",
                        width: I,
                        height: I
                      }
                    )
                  }
                )
              }
            ),
            /* @__PURE__ */ t(
              "span",
              {
                className: c(e["select__item-label"], n && e["select__item-label--disabled"]),
                children: [
                  /* @__PURE__ */ a("span", { className: e["select__item-label-text"], children: l.label }),
                  l.labelEnd && /* @__PURE__ */ a("span", { className: e["select__item-label-end"], children: l.labelEnd })
                ]
              }
            )
          ]
        },
        h
      );
    }),
    i && u && /* @__PURE__ */ t("div", { className: e.select__error, children: [
      /* @__PURE__ */ a(N, { icon: "info", width: "16px", decorative: !0 }),
      /* @__PURE__ */ a("p", { id: `error-${d}`, role: "alert", className: e["select__error-text"], children: u })
    ] })
  ] });
}, F = (s) => s.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
export {
  Q as RocheUISelect
};
